export const OWNER_PANEL_USERNAME =
  process.env.REACT_APP_OWNER_PANEL_USERNAME || "CarterB";

export function accountKey(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[.#$/[\]\s]/g, "");
}

export function isOwnerPanelUser(user) {
  const allowed = accountKey(OWNER_PANEL_USERNAME);
  return accountKey(user?.id) === allowed || accountKey(user?.username) === allowed;
}
